import { Component, OnInit } from '@angular/core';
import { CommonService } from 'src/service/common.service';
@Component({
  selector: 'app-technique-described',
  templateUrl: './technique-described.page.html',
  styleUrls: ['./technique-described.page.scss'],
})
export class TechniqueDescribedPage implements OnInit {

  constructor(
    private com: CommonService,
  ) { }

  ngOnInit() {
  }
  dismissModal(){
    const that =this;
    this.com.goBack();
  }
}
